"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreaChartDescriptor = void 0;
var tslib_1 = require("tslib");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var PluggableAreaChart_1 = require("./PluggableAreaChart");
var BigChartDescriptor_1 = require("../BigChartDescriptor");
var drillDownUtil_1 = require("../drillDownUtil");
var embeddingCodeGenerator_1 = require("../../../utils/embeddingCodeGenerator");
var chartCodeGenUtils_1 = require("../chartCodeGenUtils");
var AreaChartDescriptor = /** @class */ (function (_super) {
    tslib_1.__extends(AreaChartDescriptor, _super);
    function AreaChartDescriptor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getEmbeddingCode = embeddingCodeGenerator_1.getReactEmbeddingCodeGenerator({
            component: {
                importType: "named",
                name: "AreaChart",
                package: "@gooddata/sdk-ui-charts",
            },
            insightToProps: embeddingCodeGenerator_1.getInsightToPropsConverter({
                measures: embeddingCodeGenerator_1.multipleAttributesOrMeasuresBucketConversion("measures", sdk_ui_1.BucketNames.MEASURES),
                viewBy: embeddingCodeGenerator_1.multipleAttributesBucketConversion("viewBy", sdk_ui_1.BucketNames.VIEW),
                stackBy: embeddingCodeGenerator_1.singleAttributeBucketConversion("stackBy", sdk_ui_1.BucketNames.STACK),
                filters: embeddingCodeGenerator_1.filtersInsightConversion("filters"),
                sortBy: embeddingCodeGenerator_1.sortsInsightConversion("sortBy"),
                config: chartCodeGenUtils_1.chartConfigInsightConversion("config"),
                locale: embeddingCodeGenerator_1.localeInsightConversion("locale"),
                execConfig: embeddingCodeGenerator_1.executionConfigInsightConversion("execConfig"),
            }),
            additionalFactories: chartCodeGenUtils_1.chartAdditionalFactories(),
        });
        return _this;
    }
    AreaChartDescriptor.prototype.getFactory = function () {
        return function (params) { return new PluggableAreaChart_1.PluggableAreaChart(params); };
    };
    AreaChartDescriptor.prototype.applyDrillDown = function (insight, drillDownContext, backendSupportsElementUris) {
        var withFilters = this.addFilters(insight, drillDownContext.drillDefinition, drillDownContext.event, backendSupportsElementUris);
        return drillDownUtil_1.modifyBucketsAttributesForDrillDown(withFilters, drillDownContext.drillDefinition);
    };
    AreaChartDescriptor.prototype.getMeta = function () {
        return {
            documentationUrl: "https://sdk.gooddata.com/gooddata-ui/docs/area_chart_component.html",
            supportsExport: true,
            supportsZooming: true,
        };
    };
    AreaChartDescriptor.prototype.addFilters = function (source, drillConfig, event, backendSupportsElementUris) {
        var cutIntersection = drillDownUtil_1.reverseAndTrimIntersection(drillConfig, event.drillContext.intersection);
        return drillDownUtil_1.addIntersectionFiltersToInsight(source, cutIntersection, backendSupportsElementUris);
    };
    return AreaChartDescriptor;
}(BigChartDescriptor_1.BigChartDescriptor));
exports.AreaChartDescriptor = AreaChartDescriptor;
//# sourceMappingURL=AreaChartDescriptor.js.map